import { Link } from 'gatsby'
import React, { useEffect, useState } from 'react'
import { ArrowRight } from 'react-feather'
import Spinner from 'react-spinkit'
import { extractPathFromWordpressUrl } from '../../utils/helpers'
import WP from '../../utils/WP'

const EmbedFile = ({ block, meta }) => {
  if (!block.attrs || !meta.media) {
    return null
  }
  const file = JSON.parse(decodeURIComponent(meta.media))

  return (
    <Link to={`/media${extractPathFromWordpressUrl(file.link)}`}>
      <div className="linked-media with-bg-waves mb-em card">
        <h3 className="is-marginless ta-l has-text-light">{file.title}</h3>
        <div className="w-min is-hcentered fd-r mt-16">
          <p className="ta-l has-text-white semibold m-0">Read More</p>
          <ArrowRight size={20} color="white" className="ml-4" />
        </div>
      </div>
    </Link>
  )
}

export default EmbedFile
